import apiService from './api-service';

const service = {
  cancelImport: (file) => {

  },
  confirmImport: (projectId, profiles, fileGuid, fileName, url, doneCallback) => {
    abp.ajax({
      url: url,
      type: 'POST',
      data: JSON.stringify({
        projectId: projectId,
        fileGuid: fileGuid,
        fileName: fileName,
        selectedProfiles: profiles.filter(p => p.shouldImport === true).map(p => p.profileId)
      })
    }).done((result) => {
      doneCallback(result);
    })
  },
  profilePreview0: (profileId, fileGuid, url, doneCallback) => {
    const promise = new Promise((resolve, reject) => {
      abp.ajax({
        url: url,
        type: 'POST',
        data: JSON.stringify({})
      }).done(result => {
        resolve(result);
      }).fail(() => {
        alert("Communication failed")
      });
    })
  },
  profilePreview: (profileId, fileGuid, url) => apiService.post(url, { profileId, fileGuid }),
}


export default service;


// WEBPACK FOOTER //
// ./App/components/modules/measurement-validator/services/service.js